import { convertLegacyRouteRefs } from '@backstage/core-compat-api';
import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { CreateAppRouteBinder } from '@backstage/frontend-app-api';

import { ExternalRoutes, Routes, rootRouteRef } from './routes';

export const confidenceMaterializedSegmentsPlugin = createPlugin({
  id: 'confidence-flags-module-materialized-segments',
  routes: {
    ...Routes,
  },
  externalRoutes: {
    ...ExternalRoutes,
  },
});

export const bindMaterializedSegmentsRoutes = (
  bind: CreateAppRouteBinder,
  extraRoutes?: Parameters<typeof convertLegacyRouteRefs>[0],
) => {
  bind(
    convertLegacyRouteRefs(confidenceMaterializedSegmentsPlugin.externalRoutes),
    convertLegacyRouteRefs({ ...extraRoutes }),
  );
};

export const ConfidenceMaterializedSegmentsPage =
  confidenceMaterializedSegmentsPlugin.provide(
    createRoutableExtension({
      name: 'ConfidenceMaterializedSegmentsPage',
      component: () =>
        import(
          /* webpackChunkName: "confidence-flags-module-materialized-segments", webpackPrefetch: 10 */ './Router'
        ).then(m => m.Router),
      mountPoint: rootRouteRef,
    }),
  );
